import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ProxmoxService } from './proxmox.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private proxmoxService: ProxmoxService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if user is authenticated
    if (this.proxmoxService.isAuthenticated()) {
      // For client dashboard, check if user has client role
      if (state.url.includes('/client-dashboard') || state.url.includes('/vm-details')) {
        // In a real implementation, you would check the user's role
        // For now, we'll allow access to client dashboard
        return true;
      }
      
      // For admin dashboard, check if user has admin role
      if (state.url.includes('/admin-dashboard')) {
        // Check if the user is an admin (in a real app, this would be based on actual roles)
        // For now, we'll assume that if the user is authenticated and accessing admin routes,
        // they should be an admin
        return true;
      }
      
      return true;
    } else {
      // Redirect to appropriate login page based on the route
      if (state.url.includes('/client-dashboard') || state.url.includes('/vm-details')) {
        this.router.navigate(['/client-login']);
      } else {
        this.router.navigate(['/log-in']);
      }
      return false;
    }
  }
}